<template>
  <div v-if="smetaManagerDrawerOpen">
    <div
      style="display: flex; align-items: center; gap: 10px; width: 100%; margin-bottom: 10px;"
    >
      <BackBtn @click="() => smetaManagerDrawerOpen = false" />
      <div class="top-bar">
        <PageTitle hideMarginLeft>
          Смета менеджера - Проект #{{ activeProjectId }}
          <span
            v-if="activeProjectData"
            style="font-size: 14px; font-weight: normal; color: #666; margin-left: 10px;"
          >
            ({{ activeProjectData.resident_name }},
            {{ activeProjectData.project_type_name }})
          </span>
        </PageTitle>
      </div>
    </div>

    <ProjectSmetaManager
      v-if="activeProjectData"
      :project-id="activeProjectId"
      :resident-id="activeProjectData.resident_id"
      :project-type-id="activeProjectData.project_type_id"
    />
  </div>

  <div v-else-if="smetaDrawerOpen">
    <div
      style="display: flex; align-items: center; gap: 10px; width: 100%; margin-bottom: 10px;"
    >
      <BackBtn @click="() => smetaDrawerOpen = false" />
      <div class="top-bar">
        <PageTitle hideMarginLeft>
          Смета проекта - Проект #{{ activeProjectId }}
          <span
            v-if="activeProjectData"
            style="font-size: 14px; font-weight: normal; color: #666; margin-left: 10px;"
          >
            ({{ activeProjectData.resident_name }},
            {{ activeProjectData.project_type_name }})
          </span>
        </PageTitle>
      </div>
    </div>
    <ProjectSmetaTabs :project-id="activeProjectId" />
  </div>

  <div v-else-if="smetaNewDrawerOpen">
    <div
      style="display: flex; align-items: center; gap: 10px; width: 100%; margin-bottom: 10px;"
    >
      <BackBtn @click="() => smetaNewDrawerOpen = false" />
      <div class="top-bar">
        <PageTitle hideMarginLeft>
          Смета новая - Проект #{{ activeProjectId }}
          <span
            v-if="activeProjectData"
            style="font-size: 14px; font-weight: normal; color: #666; margin-left: 10px;"
          >
            ({{ activeProjectData.resident_name }},
            {{ activeProjectData.project_type_name }})
          </span>
        </PageTitle>
        <div class="tw-flex tw-items-center tw-gap-4">
          <CustomSelect
            :options="smetaNewEntranceOptions"
            label="Подъезд"
            option-label-key="label"
            option-value-key="project_entrance_id"
            :value="smetaNewEntranceId"
            @change="onSmetaNewEntranceChange"
            placeholder="Все подъезды"
            :clearable="false"
          />
          <CustomSelect
            :options="smetaNewFloorOptions"
            label="Этаж"
            option-label-key="label"
            option-value-key="floor_map_id"
            :value="smetaNewFloorMapId"
            @change="onSmetaNewFloorChange"
            placeholder="Все этажи"
            :clearable="false"
            :disable="!smetaNewEntranceId"
          />
        </div>
      </div>
    </div>

    <div class="smeta-tabs tw-mb-4">
      <button
        class="smeta-tab"
        :class="{ 'smeta-tab--active': smetaNewWhat === 'general' }"
        @click="onSmetaNewWhatChange('general')"
      >
        Общая смета
      </button>
      <button
        class="smeta-tab"
        :class="{ 'smeta-tab--active': smetaNewWhat === 'contractor' }"
        @click="onSmetaNewWhatChange('contractor')"
      >
        Смета подрядчика
      </button>
      <button
        class="smeta-tab"
        :class="{ 'smeta-tab--active': smetaNewWhat === 'team' }"
        @click="onSmetaNewWhatChange('team')"
      >
        Смета команды проекта
      </button>
    </div>

    <ProjectSmetaNew
      v-if="activeProjectId"
      :project-id="activeProjectId"
      :resident-id="activeProjectData && activeProjectData.resident_id"
      :project-entrance-id="smetaNewEntranceId"
      :floor-map-id="smetaNewFloorMapId"
      :what="smetaNewWhat"
      @error="showErrorSnackbar"
    />
  </div>
  <div v-else-if="smetaAnomaliesDrawerOpen">
    <div
      style="display: flex; align-items: center; gap: 10px; width: 100%; margin-bottom: 10px;"
    >
      <BackBtn @click="() => smetaAnomaliesDrawerOpen = false" />
      <div class="top-bar">
        <PageTitle hideMarginLeft>
          Журнал изменений сметы - Проект #{{ activeProjectId }}
          <span
            v-if="activeProjectData"
            style="font-size: 14px; font-weight: normal; color: #666; margin-left: 10px;"
          >
            ({{ activeProjectData.resident_name }},
            {{ activeProjectData.project_type_name }})
          </span>
        </PageTitle>
      </div>
    </div>

    <ProjectSmetaAnomalies
      v-if="activeProjectId"
      :project-id="activeProjectId"
    />
  </div>

  <div v-else-if="smetaCompareNewDrawerOpen">
    <div
      style="display: flex; align-items: center; gap: 10px; width: 100%; margin-bottom: 10px;"
    >
      <BackBtn @click="() => smetaCompareNewDrawerOpen = false" />
      <div class="top-bar">
        <PageTitle hideMarginLeft>
          Сравнение сметы новая - Проект #{{ activeProjectId }}
          <span
            v-if="activeProjectData"
            style="font-size: 14px; font-weight: normal; color: #666; margin-left: 10px;"
          >
            ({{ activeProjectData.resident_name }},
            {{ activeProjectData.project_type_name }})
          </span>
        </PageTitle>
      </div>
    </div>

    <ProjectSmetaCompareNew
      v-if="activeProjectId"
      :project-id="activeProjectId"
    />
  </div>

  <div v-else-if="smetaHubOpen">
    <div
      style="display: flex; align-items: center; gap: 10px; width: 100%; margin-bottom: 10px;"
    >
      <BackBtn @click="() => smetaHubOpen = false" />
      <div class="top-bar">
        <PageTitle hideMarginLeft>
          Смета - Проект #{{ activeProjectId }}
          <span
            v-if="activeProjectData"
            style="font-size: 14px; font-weight: normal; color: #666; margin-left: 10px;"
          >
            ({{ activeProjectData.resident_name }},
            {{ activeProjectData.project_type_name }})
          </span>
        </PageTitle>
      </div>
    </div>

    <ProjectSmetaHub
      v-if="activeProjectData"
      :project-id="activeProjectId"
      :resident-id="activeProjectData.resident_id"
      :project-type-id="activeProjectData.project_type_id"
    />
  </div>

  <div v-else>
    <div
      style="display: flex; align-items: center; gap: 10px; width: 100%; margin-bottom: 10px;"
    >
      <BackBtn @click="this.onBackClick" />
      <div class="top-bar">
        <PageTitle hideMarginLeft> Проекты </PageTitle>
        <CustomButton class="top-bar__btn" @click="this.startTourGuide">
          <img src="/img/icons/help.svg" alt="help" />
          <span>Подсказка</span>
        </CustomButton>
      </div>
    </div>

    <div class="header">
      <div class="header__card">
        <div>ЖК: {{ this.selectedData.resident_name }}</div>
        <div>Тип проекта: {{ this.selectedData.project_type_name }}</div>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <CustomButton
          class="header__create-btn header__create-btn--ddu"
          :outlined="true"
          color="primary"
          @click="openDduDownloadDialogByResident"
        >
          <span>Скачать ДДУ по ЖК</span>
        </CustomButton>
        <CustomButton
          class="header__create-btn"
          @click="this.handleAddClick"
          id="create-project"
        >
          <span>Создать проект</span>
          <q-icon name="add" class="header__create-btn-icon" size="16px" />
        </CustomButton>
      </div>
    </div>

    <div class="projects-grid-table">
    <CustomTable
      title="Проекты"
      :rowsData="this.rowsData"
      :columns="this.selectedProjectsColumns"
      :loading="isFetching"
      :small="true"
      :show-search="true"
      :custom-body="true"
      :update-data="this.getData"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell
            align="center"
            vertical-align="center"
            id="project-info"
          >
            <div style="font-weight:600; cursor:default;">
              {{ props.row.project_id }}
              <q-tooltip anchor="top middle" self="bottom middle" class="bg-grey-8 text-white" style="font-size:12px;">ID проекта</q-tooltip>
            </div>
            <CustomIcon
              icon="edit"
              title="Редактировать"
              @click="handleEditClick(props.row)"
            />
          </custom-table-cell>

          <custom-table-cell
            align="left"
            vertical-align="center"
            :class="this.getFillClass(props.row.is_filled)"
          >
            <div
              v-if="Array.isArray(props.row.entrances_info)"
              style="display: flex; gap: 7px; justify-content: center; flex-wrap: wrap; width: 110px;"
            >
              <div
                v-for="(entrance, index) in props.row.entrances_info"
                :key="index"
              >
                <q-btn
                  :label="entrance.entrance_num"
                  :style="{ width: '18px', height: '18px !important', fontSize: '12px', padding: '0 !important', minHeight: '18px !important', backgroundColor: entrance.color || '', color: '#ffffff', lineHeight: '12px' }"
                  :color="this.getTextColorByBackground(entrance.color) || '#133d67'"
                  flat
                  @click="handleEntranceClick(props.row, entrance)"
                >
                  <q-tooltip
                    v-if="!!entrance.description"
                    class="bg-white"
                    :style="{ color: entrance.color || '#133d67', fontSize: '12px' }"
                    anchor="top middle"
                    :offset="[30, 30]"
                    >{{ entrance.description }}</q-tooltip
                  >
                </q-btn>
                <div
                  v-if="!!entrance.block_name"
                  style="text-align: center; font-size: 11px; color: #404040;"
                >
                  {{ entrance.block_name || '' }}
                  <q-tooltip>Блок</q-tooltip>
                </div>
              </div>
            </div>
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <q-btn size="xs" dense="">
              <q-icon
                name="fas fa-door-open"
                style="font-size: 16px; color: #1767ab;"
              >
              </q-icon>
              <q-popup-proxy
                :ref="`popupProjectEntrance${props.row.project_id}`"
                transition-show="scale"
                transition-hide="scale"
                :breakpoint="0"
                @show="() => this.onEditEntrances(props.row.resident_id, props.row.project_id)"
              >
                <q-card style="padding: 25px 15px; width: 270px;">
                  <q-linear-progress
                    v-if="this.changingEntrances || this.fetchingEntrances"
                    indeterminate
                  />
                  <div class="form__item">
                    <div class="entrance-selector">
                      <div class="entrance-selector__label">
                        Выбрать подъезд<span style="color: red;">*</span>
                      </div>
                      <CustomSelect
                        :options="this.entranceOptions"
                        label="Подъезд"
                        option-label-key="label"
                        option-value-key="entrance"
                        @change="(value) => this.onEntranceChange(props.row, value)"
                        placeholder="Выберите подъезд"
                        clearable
                      />
                    </div>
                  </div>
                </q-card>
              </q-popup-proxy>
              <q-tooltip>Изменить подъезды</q-tooltip>
            </q-btn>
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <div style="font-size:12px; white-space:nowrap; cursor:default;">
              {{ props.row.start_date }} — {{ props.row.finish_date }}
              <q-tooltip anchor="top middle" self="bottom middle" class="bg-grey-8 text-white" style="font-size:12px;">Период работ</q-tooltip>
            </div>
            <div class="cell-section-divider"></div>
            <Clickable style="font-size:11px;" @click="this.handleExecutorClick(props.row)">
              <q-icon name="person" size="12px" style="margin-right:2px;" />
              Исполнители
            </Clickable>
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <div v-if="props.row.project_status_code === 'CANCELLED'" class="project-status-cancelled">
              {{ props.row.project_status_name || 'Отменён' }}
            </div>
            <div
              v-else
              class="step-compact"
              @click="openTimeline(props.row)"
            >
              <div class="step-compact__name">
                {{ steps[getCurrentStepForProject(props.row.project_timeline_step_code, props.row.project_status_name)]?.title || '—' }}
              </div>
              <div class="step-compact__bar-row">
                <div class="step-compact__bar">
                  <div
                    class="step-compact__bar-fill"
                    :style="{ width: Math.round(((getCurrentStepForProject(props.row.project_timeline_step_code, props.row.project_status_name) + 1) / steps.length) * 100) + '%' }"
                  ></div>
                </div>
                <span class="step-compact__fraction">
                  {{ getCurrentStepForProject(props.row.project_timeline_step_code, props.row.project_status_name) + 1 }}/{{ steps.length }}
                </span>
              </div>
              <q-tooltip anchor="bottom middle" self="top middle" class="bg-white step-tooltip">
                <div v-for="(step, idx) in steps" :key="idx" class="step-tooltip__item" :class="{ 'step-tooltip__item--active': idx === getCurrentStepForProject(props.row.project_timeline_step_code, props.row.project_status_name), 'step-tooltip__item--done': idx < getCurrentStepForProject(props.row.project_timeline_step_code, props.row.project_status_name) }">
                  <q-icon :name="idx < getCurrentStepForProject(props.row.project_timeline_step_code, props.row.project_status_name) ? 'check_circle' : idx === getCurrentStepForProject(props.row.project_timeline_step_code, props.row.project_status_name) ? 'radio_button_checked' : 'radio_button_unchecked'" size="14px" />
                  {{ step.title }}
                </div>
              </q-tooltip>
            </div>
          </custom-table-cell>

          <!-- Тип проекта / Аванс / НДС — объединённая колонка -->
          <custom-table-cell align="center" vertical-align="center">
            <!-- Тип проекта -->
            <div style="font-size:12px; font-weight:600; cursor:default;">
              {{ props.row.external_resource_code || '-' }}
              <q-tooltip anchor="top middle" self="bottom middle" class="bg-grey-8 text-white" style="font-size:12px;">Тип проекта</q-tooltip>
            </div>
            <!-- Привязанный УСП проект -->
            <div v-if="props.row.sbs_project_name" class="sbs-project-badge">
              {{ props.row.sbs_project_name }}
              <q-tooltip anchor="top middle" self="bottom middle" class="bg-blue text-white" style="font-size:13px;">Привязанный проект УСП</q-tooltip>
            </div>
            <!-- Статус привязки УСП -->
            <div v-if="props.row.usp_check_link_text" style="margin-top:3px;">
              <span v-if="props.row.usp_check_link_text === 'OK'" class="usp-check-link-badge">
                OK
                <q-tooltip anchor="top middle" self="bottom middle" class="bg-green text-white" style="font-size:13px;">Проект полностью привязан к УСП</q-tooltip>
              </span>
              <q-icon v-else name="warning" color="orange" size="20px" style="cursor:pointer;">
                <q-tooltip anchor="top middle" self="bottom middle" class="bg-orange text-white" style="font-size:13px; max-width:300px;">{{ props.row.usp_check_link_text }}</q-tooltip>
              </q-icon>
            </div>
            <!-- Аванс -->
            <div class="cell-section-divider"></div>
            <div style="font-size:11px; color:#444; cursor:default;">
              {{ props.row.avans !== null && props.row.avans !== undefined ? props.row.avans : '—' }}
              <q-tooltip anchor="top middle" self="bottom middle" class="bg-grey-8 text-white" style="font-size:12px;">Аванс</q-tooltip>
            </div>
            <!-- Лимит материалов -->
            <div class="material-limit-badge">
              <div class="material-limit-badge__content">
                <span class="material-limit-badge__text">Лимит: {{ formatNumber(props.row.material_sum_limit || "") }} ₸</span>
              </div>
              <q-icon name="edit" size="13px" class="material-limit-badge__edit-icon" @click.stop="handleEditMaterialLimit(props.row)" />
              <q-tooltip anchor="top middle" self="bottom middle" class="bg-blue text-white" style="font-size:13px;">Лимит суммы на материалы для проекта</q-tooltip>
            </div>
            <!-- НДС -->
            <div class="cell-section-divider"></div>
            <div>
              <q-chip
                v-if="props.row.is_contractor_nds !== null"
                :label="props.row.is_contractor_nds === false ? 'Без НДС' : 'НДС'"
                outline square style="font-weight:700; cursor:default;" size="sm"
                :color="props.row.is_contractor_nds === false ? 'red' : 'green'"
              >
                <q-tooltip anchor="top middle" self="bottom middle" class="bg-grey-8 text-white" style="font-size:12px;">
                  {{ props.row.is_contractor_nds === false ? 'Подрядчик работает без НДС' : 'Подрядчик работает с НДС' }}
                </q-tooltip>
              </q-chip>
              <span v-else style="color:#999; font-style:italic; font-size:11px; cursor:default;">
                НДС не указан
                <q-tooltip anchor="top middle" self="bottom middle" class="bg-grey-8 text-white" style="font-size:12px;">Признак НДС не задан</q-tooltip>
              </span>
            </div>
          </custom-table-cell>

          <!-- Предзаказ / Смета утверждена — объединённая колонка -->
          <custom-table-cell align="center" vertical-align="center">
            <div class="toggle-cell-wrapper" style="margin-bottom:4px;">
              <q-spinner v-if="preorderLoading[props.row.project_id]" size="18px" color="primary" />
              <q-toggle
                v-show="!preorderLoading[props.row.project_id]"
                :model-value="!!props.row.is_preorder"
                :disable="preorderLoading[props.row.project_id]"
                @update:model-value="(val) => onPreorderChange(props.row, val)"
                label="Предзаказ"
                dense color="primary"
              >
                <q-tooltip anchor="top middle" self="bottom middle" class="bg-grey-8 text-white" style="font-size:12px;">Предзаказ — проект в режиме предварительного заказа</q-tooltip>
              </q-toggle>
            </div>
            <div class="cell-section-divider"></div>
            <div class="toggle-cell-wrapper">
              <q-spinner v-if="smetaConfirmLoading[props.row.project_id]" size="18px" color="primary" />
              <q-toggle
                v-show="!smetaConfirmLoading[props.row.project_id]"
                :model-value="!!props.row.is_smeta_confirm"
                :disable="smetaConfirmLoading[props.row.project_id]"
                @update:model-value="(val) => onSmetaConfirmChange(props.row, val)"
                label="Смета ✓"
                dense color="green"
              >
                <q-tooltip anchor="top middle" self="bottom middle" class="bg-grey-8 text-white" style="font-size:12px;">Смета утверждена</q-tooltip>
              </q-toggle>
            </div>
          </custom-table-cell>

          <custom-table-cell
            align="left"
            vertical-align="center"
            style="width: 150px;"
          >
            <div v-if="props.row.doc_info && props.row.doc_info.length > 0">
              <div
                v-for="(doc, index) in props.row.doc_info"
                :key="index"
                style="display: flex; flex-direction: column;"
              >
                <div
                  style="display: flex; align-items: center; justify-content: space-between;"
                >
                  <span
                    class="doc-link"
                    @click="downloadDoc(doc.project_agreement_id, doc.doc_name)"
                    >{{
                    doc.doc_name }}</span
                  >
                  <q-icon
                    v-if="doc.error"
                    name="error_outline"
                    color="red"
                    class="doc-1c-icon"
                  />
                  <q-icon
                    v-else-if="doc.is_sent_to_1c === 1"
                    name="cloud_done"
                    color="positive"
                    class="doc-1c-icon"
                  />
                  <q-spinner
                    v-if="infoLoading[doc.project_agreement_id]"
                    color="primary"
                    size="16px"
                  />
                  <q-icon
                    v-else
                    name="delete"
                    @click="deleteDoc(doc.project_agreement_id)"
                    color="red"
                    style="cursor: pointer; font-size: 16px;"
                  />
                </div>
                <q-tooltip
                  class="bg-blue-grey-7 text-body2"
                  anchor="top middle"
                  :offset="[85, 85]"
                >
                  <template v-if="doc.show_sum">
                    <div class="tooltip-title">{{ doc.sum_title }}:</div>
                    <div class="signer-row" style="margin-bottom: 8px;">{{ doc.doc_sum }}</div>
                  </template>

                  <template v-if="doc.is_sent_to_1c === 1 || doc.error">
                    <div class="tooltip-title">1С:</div>
                    <div class="tooltip-section">
                      <div class="signer-row" v-if="doc.is_sent_to_1c === 1">
                        <span class="signer-name">Отправлен в 1С</span>
                        <q-icon
                          name="check_circle"
                          color="positive"
                          class="signer-icon"
                        />
                      </div>
                      <div class="signer-row" v-if="doc.kod_bk">
                        <span class="signer-name">Код 1С: {{ doc.kod_bk }}</span>
                      </div>
                      <div class="signer-row doc-1c-error" v-if="doc.error">
                        <q-icon
                          name="error_outline"
                          color="red-4"
                          class="signer-icon"
                        />
                        <span class="signer-name">{{ doc.error }}</span>
                      </div>
                    </div>
                  </template>

                  <div class="tooltip-title">Подписанты:</div>

                  <div class="signer-row" v-if="doc.contractor_fio">
                    <span class="signer-name">{{ doc.contractor_fio }}</span>
                    <q-icon
                      name="check_circle"
                      color="positive"
                      class="signer-icon"
                      v-if="doc.contractor_sign"
                    />
                    <q-icon
                      name="pending"
                      color="warning"
                      class="signer-icon"
                      v-else
                    />
                  </div>

                  <div class="signer-row" v-if="doc.project_head_fio">
                    <span class="signer-name">{{ doc.project_head_fio }}</span>
                    <q-icon
                      name="check_circle"
                      color="positive"
                      class="signer-icon"
                      v-if="doc.project_head_sign"
                    />
                    <q-icon
                      name="pending"
                      color="warning"
                      class="signer-icon"
                      v-else
                    />
                  </div>
                </q-tooltip>
              </div>
            </div>
            <span
              v-else
              style="color: #999; font-style: italic; font-size: 12px;"
              >Нет документов</span
            >
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <CustomDropdown
              :loading="infoLoading[props.row.project_id] || this.actionsLoading[props.row.project_id]"
              @click="action => action.type === 'generateDoc' ? this.handleClickDoc(props.row.project_id) : this.handleAction(props.row, action.action, props.row.project_id)"
              :options="this.getActionsDropdown(props.row)"
              title="Действие"
              :groupLabels="this.getGroupLabels"
              :isGrouped="true"
            />
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
    </div>

    <!-- Timeline drawer (правая панель с этапами) -->
    <q-drawer
      v-model="timelineDrawerOpen"
      side="right"
      overlay
      bordered
      :width="480"
    >
      <div v-if="timelineDrawerRow" style="padding: 24px;">
        <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:20px;">
          <div>
            <div style="font-weight:700; font-size:16px;">Этапы проекта #{{ timelineDrawerRow.project_id }}</div>
            <div style="font-size:13px; color:#666; margin-top:2px;">{{ timelineDrawerRow.resident_name }}, {{ timelineDrawerRow.project_type_name }}</div>
          </div>
          <q-btn flat round icon="close" @click="timelineDrawerOpen = false" />
        </div>
        <div v-if="timelineDrawerRow.project_status_code === 'CANCELLED'" class="project-status-cancelled">
          {{ timelineDrawerRow.project_status_name || 'Отменён' }}
        </div>
        <ProgressBar
          v-else
          :steps="steps"
          :current-step="getCurrentStepForProject(timelineDrawerRow.project_timeline_step_code, timelineDrawerRow.project_status_name)"
          size="md"
          :index="false"
        />
        <div style="margin-top:24px; font-size:12px; color:#888;">
          Текущий этап:
          <strong>{{ steps[getCurrentStepForProject(timelineDrawerRow.project_timeline_step_code, timelineDrawerRow.project_status_name)]?.title || '—' }}</strong>
        </div>
      </div>
    </q-drawer>

    <div class="replace-materials-drawer">
      <q-drawer
        v-model="isReplaceMaterialsDrawerOpen"
        side="right"
        overlay
        bordered
        :width="700"
      >
        <ChangeProjectMaterials
          v-if="isReplaceMaterialsDrawerOpen"
          :onClose="() => isReplaceMaterialsDrawerOpen = false"
          :projectId="activeProjectId"
          :projectData="activeProjectData"
        />
      </q-drawer>
    </div>

    <div class="resort-material-drawer">
      <q-drawer
        v-model="isResortMaterialDrawerOpen"
        side="right"
        overlay
        bordered
        :width="700"
      >
        <ResortMaterial
          v-if="isResortMaterialDrawerOpen"
          :onClose="() => isResortMaterialDrawerOpen = false"
          :projectId="activeProjectId"
          :projectData="activeProjectData"
        />
      </q-drawer>
    </div>

    <div class="replace-materials-drawer">
      <q-drawer
        v-model="docsDrawerOpen"
        :width="windowWidth < this.drawerWidth ? windowWidth : this.drawerWidth"
        :overlay="true"
        side="right"
        bordered
      >
        <div
          style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid #eee; height: 51px;"
        >
          <div
            @click="() => docsDrawerOpen = false"
            style="font-weight: 600; font-size: 16px; cursor: pointer; display: flex; align-items: center; gap: 5px;"
          >
            <q-icon name="fas fa-chevron-left" class="back__icon" />
            Документы проекта #{{ this.activeProjectId }}
          </div>
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="() => docsDrawerOpen = false"
          />
        </div>
        <div class="tw-p-4">
          <ProjectDocs
            v-if="docsDrawerOpen"
            :project-id="this.activeProjectId"
          />
        </div>
      </q-drawer>
    </div>

    <div class="load-revit-drawer">
      <q-drawer
        v-model="loadRevitDrawerOpen"
        :width="Math.max(400, Math.floor(windowWidth / 2))"
        :overlay="true"
        side="right"
        bordered
      >
        <div
          style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid #eee; height: 51px;"
        >
          <div
            @click="() => loadRevitDrawerOpen = false"
            style="font-weight: 600; font-size: 16px; cursor: pointer; display: flex; align-items: center; gap: 5px;"
          >
            <q-icon name="fas fa-chevron-left" class="back__icon" />
            Подгрузить Revit проект
          </div>
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="() => loadRevitDrawerOpen = false"
          />
        </div>
        <ProjectLoadRevit
          v-if="loadRevitDrawerOpen && activeProjectId && activeProjectData"
          :project-id="activeProjectId"
          :resident-id="activeProjectData.resident_id"
          :project-type-id="activeProjectData.project_type_id"
          :initial-project-entrance-id="loadRevitInitialEntranceId"
          :initial-bim-project-id="loadRevitInitialBimProjectId"
          :initial-operation-key="loadRevitInitialOperationKey"
          :import-in-progress="loadRevitImportInProgress"
          @close="() => loadRevitDrawerOpen = false"
          @success="getData"
        />
      </q-drawer>
    </div>

    <div class="smeta-compare-drawer">
      <q-drawer
        v-model="smetaCompareDrawerOpen"
        :width="windowWidth < 1400 ? windowWidth : 1400"
        :overlay="true"
        side="right"
        bordered
      >
        <div
          style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid #eee; height: 51px;"
        >
          <div
            @click="() => smetaCompareDrawerOpen = false"
            style="font-weight: 600; font-size: 16px; cursor: pointer; display: flex; align-items: center; gap: 5px;"
          >
            <q-icon name="fas fa-chevron-left" class="back__icon" />
            Сравнение смет - Проект #{{ this.activeProjectId }}
          </div>
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="() => smetaCompareDrawerOpen = false"
          />
        </div>
        <div class="tw-p-4">
          <ProjectSmetaCompare
            v-if="smetaCompareDrawerOpen && activeProjectId"
            :project-id="activeProjectId"
          />
        </div>
      </q-drawer>
    </div>


    <div class="floors-work-drawer">
      <q-drawer
        v-model="floorsWorkDrawerOpen"
        :width="windowWidth < 500 ? windowWidth : 500"
        :overlay="true"
        side="right"
        bordered
      >
        <div
          style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid #eee; height: 51px;"
        >
          <div
            @click="() => floorsWorkDrawerOpen = false"
            style="font-weight: 600; font-size: 16px; cursor: pointer; display: flex; align-items: center; gap: 5px;"
          >
            <q-icon name="fas fa-chevron-left" class="back__icon" />
            Работа с этажами - Проект #{{ this.activeProjectId }}
          </div>
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="() => floorsWorkDrawerOpen = false"
          />
        </div>
        <div class="tw-p-4">
          <ProjectFloorsWork
            v-if="floorsWorkDrawerOpen && activeProjectId"
            :project-id="activeProjectId"
            :project-data="activeProjectData"
          />
        </div>
      </q-drawer>
    </div>

    <q-dialog v-model="changeStatusDialogOpen" persistent>
      <q-card style="min-width: 360px;">
        <q-card-section>
          <div class="text-h6">Изменение статуса</div>
          <div class="text-caption text-grey q-mt-xs">Проект #{{ changeStatusProjectId }}</div>
        </q-card-section>
        <q-card-section>
          <CustomSelect
            :options="changeStatusOptions"
            label="Статус"
            option-label-key="project_status_name"
            option-value-key="project_status_id"
            :value="changeStatusSelectedId"
            @change="onChangeStatusSelect"
            style="width: 100%;"
            :required="true"
          />
        </q-card-section>
        <q-card-actions align="right">
          <q-btn flat label="Отмена" color="grey" v-close-popup />
          <q-btn
            unelevated
            label="Сохранить"
            color="primary"
            :loading="changeStatusLoading"
            :disable="changeStatusSelectedId == null"
            @click="onSubmitChangeStatus"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="dduDownloadDialog" persistent>
      <q-card class="ddu-download-card">
        <q-card-section class="ddu-download-card__header">
          <div class="ddu-download-card__title-row">
            <q-icon name="description" size="28px" class="ddu-download-card__icon" />
            <div>
              <div class="text-h6 ddu-download-card__title">Скачать файл ДДУ</div>
              <div class="ddu-download-card__subtitle">Отчёт по выполненным работам за период</div>
            </div>
          </div>
          <div class="ddu-download-card__resident">
            {{ dduDownloadResidentName || 'ЖК не выбран' }}
          </div>
        </q-card-section>
        <q-card-section class="ddu-download-card__period">
          <div class="ddu-download-card__period-label">Период</div>
          <CustomDateRange
            :value="dduDownloadDateRange"
            @change_range="dduDownloadDateRange = $event"
            placeholder="Выберите период"
            full-width
            two-fields
            class="ddu-download-card__date-range"
          />
        </q-card-section>
        <q-separator />
        <q-card-actions align="right" class="ddu-download-card__actions">
          <q-btn flat label="Отмена" color="grey" no-caps v-close-popup />
          <q-btn
            unelevated
            no-caps
            label="Скачать"
            color="primary"
            :loading="dduDownloadLoading"
            :disable="!dduDownloadDateRange?.from || !dduDownloadDateRange?.to"
            @click="onDduDownloadSubmit"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="transferFloorDialogOpen" persistent>
      <q-card style="min-width: 400px;">
        <q-card-section>
          <div class="text-h6">Перенести этаж или подъезд в другой проект</div>
          <div class="text-caption text-grey q-mt-xs">Проект #{{ transferFloorProjectId }}</div>
        </q-card-section>
        <q-card-section class="q-gutter-md">
          <div>
            <div class="text-caption q-mb-xs">Что переносить</div>
            <q-btn-toggle
              v-model="transferMode"
              spread
              no-caps
              toggle-color="primary"
              :options="[
                { label: 'Весь подъезд', value: 'entrance' },
                { label: 'Этаж', value: 'floor' },
              ]"
            />
          </div>
          <CustomSelect
            :options="transferFloorEntranceOptions"
            option-value-key="entrance"
            option-label-key="label"
            :value="transferFloorSelectedEntrance"
            @change="onTransferFloorEntranceChange"
            placeholder="Выберите подъезд"
            label="Подъезд"
          />
          <div v-if="transferMode === 'floor'" class="transfer-floors-block">
            <div class="text-caption q-mb-xs">Этажи</div>
            <q-select
              v-model="transferFloorSelectedFloors"
              :options="transferFloorFloorOptions"
              option-value="floor_map_id"
              option-label="label"
              multiple
              emit-value
              map-options
              outlined
              dense
              placeholder="Выберите один или несколько этажей"
              :disable="!transferFloorSelectedEntrance"
              use-chips
              clearable
            />
          </div>
          <CustomSelect
            :options="transferFloorTargetOptions"
            option-value-key="project_id"
            option-label-key="label"
            :value="transferFloorTargetProjectId"
            @change="(v) => (transferFloorTargetProjectId = v)"
            placeholder="Новый проект"
            label="Новый проект"
            :loading="transferFloorLoading"
          />
          <div v-if="!transferFloorLoading && transferFloorTargetProjects.length === 0" class="text-caption text-grey q-mt-xs">
            Нет других проектов в этом ЖК с данным типом. Создайте проект или выберите другой проект в списке.
          </div>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn flat label="Отмена" color="grey" v-close-popup @click="transferFloorDialogOpen = false" />
          <q-btn
            unelevated
            :label="transferMode === 'floor' ? (transferFloorSelectedFloors.length > 1 ? 'Перенести этажи' : 'Перенести этаж') : 'Перенести подъезд'"
            color="primary"
            :loading="transferFloorLoading"
            :disable="!transferFloorTargetProjectId || (transferMode === 'floor' ? !transferFloorSelectedFloors.length : !transferFloorSelectedEntrance)"
            @click="submitTransfer"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <TourGuideManager
      ref="tourGuideManager"
      :steps="pojectsTourGuide"
      :auto-start="false"
      :show-overlay="true"
      :allow-skip="false"
      :highlight-padding="8"
      :labels="tourGuideLabels"
    />
  </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle.vue'
import ProjectPerformersInfo from "@/views/ProjectsEntry/ProjectPerformersInfo";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomIcon from "@/components/common/CustomIcon";
import Clickable from "@/components/common/Clickable";
import CheckOrClose from "@/components/common/CheckOrClose";
import ProgressBar from "@/components/common/ProgressBar";
import CustomDateRange from "@/components/common/CustomDateRange";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { MODAL_NAMES } from "@/constants";
import { TourGuideManager } from "v-tour-guide";
import {
  projectsColumns,
  selectedProjectsColumns,
  getProjectInfo,
  updProject,
  updProjectLimit,
  updWriteoffInfo,
  copyPasteEntranceProperties,
  transferEntranceProject,
  changeProjectStatus,
  getProjectStatusForChange,
  changeProjectStatusById,
  fillEntranceFlats,
  getWarranty,
  generateDoc,
  deleteDoc,
  downloadDoc,
  updateProjectEntrance,
  getEntrances,
  getResidentDetailedInfo,
  setProjectIsPreorder,
  setProjectIsSmetaConfirm,
  pojectsTourGuide,
  getTextColorByBackground,
  getFillClass,
  getProjectEntrances,
  getProjectEntranceFloors,
  getProjectsForTransfer,
  getHasGrant,
  copyFloorToProject,
  createDS,
  downloadDduReport,
  agreementCancel,
} from "@/views/ProjectsEntry/services";
import { showToast, downloadFile } from "@/services";
import CustomDropdown from "@/components/common/CustomDropdown";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";
import CustomButton from "@/components/common/CustomButton.vue";
import { useAppStore } from "@/services/store/app"
import { ref } from "vue";
import BackBtn from "@/components/common/BackBtn";
import ChangeProjectMaterials from "@/views/ProjectsEntry/ChangeProjectMaterials";
import ResortMaterial from "@/views/ProjectsEntry/ResortMaterial";
import ProjectSmeta from '../PackageEntry/ProjectSmeta.vue';
import ProjectSmetaHub from './ProjectSmetaHub.vue';
import ProjectSmetaManager from './ProjectSmetaManager.vue';
import ProjectSmetaCompare from './ProjectSmetaCompare.vue';
import ProjectSmetaCompareNew from './ProjectSmetaCompareNew.vue';
import ProjectSmetaAgreementCompare from './ProjectSmetaAgreementCompare.vue';
import ProjectDocs from './ProjectDocs.vue';
import ProjectLoadRevit from './ProjectLoadRevit.vue';
import CustomTabs from "@/components/common/CustomTabs";
import ProjectFloorsWork from './ProjectFloorsWork.vue';
import ProjectSmetaNew from './ProjectSmetaNew.vue';
import ProjectSmetaAnomalies from './ProjectSmetaAnomalies.vue';
import ProjectSmetaTabs from './components/ProjectSmetaTabs.vue';

export default {
  name: "ProjectsInfo",
  props: {
    selectedData: {
      type: Object,
      required: true
    },
  },
  components: {
    ProjectPerformersInfo,
    CheckOrClose,
    Clickable,
    CustomIcon,
    CustomTableCell,
    CustomTable,
    CustomSelect,
    CustomInput,
    CustomDropdown,
    PageTitle,
    CustomButton,
    ProgressBar,
    TourGuideManager,
    BackBtn,
    ChangeProjectMaterials,
    ResortMaterial,
    ProjectDocs,
    ProjectSmeta,
    ProjectSmetaTabs,
    ProjectSmetaManager,
    ProjectSmetaHub,
    ProjectSmetaCompare,
    ProjectSmetaCompareNew,
    ProjectSmetaAgreementCompare,
    ProjectLoadRevit,
    CustomTabs,
    CustomDateRange,
    ProjectFloorsWork,
    ProjectSmetaNew,
    ProjectSmetaAnomalies
  },
  data() {
    return {
      projectsColumns,
      pojectsTourGuide,
      selectedProjectsColumns,
      isFetching: false,
      tempBasicData: {},
      tempProjectData: {},
      drawerWidth: 1250,
      isCommonInfoOpen: false,
      fetchingEntrances: false,
      changingEntrances: false,
      infoLoading: {},
      actionsLoading: {},
      preorderLoading: {},
      smetaConfirmLoading: {},
      entranceOptionsData: [],
      rowsData: [],
      fetchingFilters: true,
      residentsOptions: [],
      projectTypesOptions: [],
      steps: ref([
        { title: "Создан", code: "CREATED" },
        { title: "Расчёт сметы", code: "ESTIMATE_READY" },
        { title: "Старт СМР", code: "START_SMR" },
        {
          title: "Сформировать документ",
          code: "DOCUMENTS",
          children: [
            { title: "Частично сформированы", code: "DOCUMENT_CREATED_PARTIAL" },
            { title: "Сформированы", code: "DOCUMENT_CREATED" }
          ]
        },
        { title: "Завершен", code: "COMPLETED" }
      ]),
      tourGuideLabels: {
        next: 'Далее',
        previous: 'Назад',
        finish: 'Завершить'
      },
      tooltip: {
        backgroundColor: '#ffffff',
        buttonHoverColor: '#ffffff',
        textColor: '#373D48',
        tooltipClass: 'custom-tour-tooltip',
        headerClass: 'custom-tour-header',
        contentClass: 'custom-tour-content',
        actionsClass: 'custom-tour-actions'
      },
      isReplaceMaterialsDrawerOpen: false,
      isResortMaterialDrawerOpen: false,
      smetaTabs: [{ name: 'entrances', label: 'По подъездам' }, { name: 'floors', label: 'По этажам' }, { name: 'materials', label: 'По материалам' }],
      smetaTab: 'entrances',
      smetaDrawerOpen: false,
      smetaNewTabs: [{ name: 'common', label: 'Общая' }],
      smetaNewTab: 'common',
      smetaNewDrawerOpen: false,
      smetaNewEntrances: [],
      smetaNewEntranceId: null,
      smetaNewFloors: [],
      smetaNewFloorMapId: null,
      smetaNewWhat: 'general',
      smetaAnomaliesDrawerOpen: false,
      smetaManagerDrawerOpen: false,
      docsDrawerOpen: false,
      loadRevitDrawerOpen: false,
      smetaCompareDrawerOpen: false,
      smetaCompareNewDrawerOpen: false,
      smetaHubOpen: false,
      timelineDrawerOpen: false,
      timelineDrawerRow: null,
      floorsWorkDrawerOpen: false,
      activeProjectId: null,
      activeProjectData: null,
      pendingOpenLoadRevit: null,
      changeStatusDialogOpen: false,
      changeStatusProjectId: null,
      changeStatusOptions: [],
      changeStatusSelectedId: null,
      changeStatusLoading: false,
      dduDownloadDialog: false,
      dduDownloadResidentId: null,
      dduDownloadResidentName: '',
      dduDownloadDateRange: { from: '', to: '' },
      dduDownloadLoading: false,
      transferFloorDialogOpen: false,
      transferFloorProjectId: null,
      transferFloorRow: null,
      transferFloorEntrances: [],
      transferFloorSelectedEntrance: null,
      transferFloorFloors: [],
      transferFloorSelectedFloors: [],
      transferFloorTargetProjects: [],
      transferFloorTargetProjectId: null,
      transferFloorLoading: false,
      transferMode: 'entrance',
      hasTransferGrant: false,
      /** Право «Вид списания» в действиях проекта (назначено админам) */
      hasWriteoffInfoGrant: false,
    };
  },
  computed: {
    filterParams() {
      return {
        resident_id: this.selectedData?.resident_id || null,
        project_type_id: this.selectedData?.project_type_id || null,
      }
    },
    entranceOptions() {
      if (!Array.isArray(this.entranceOptionsData)) {
        return [];
      }
      return (this.entranceOptionsData || []).map(e => ({
        ...e,
        label: `Подъезд ${e.entrance}`
      }))
    },
    smetaNewEntranceOptions() {
      const base = Array.isArray(this.smetaNewEntrances)
        ? this.smetaNewEntrances
        : [];

      return [
        {
          project_entrance_id: null,
          label: 'Все подъезды',
        },
        ...base,
      ];
    },
    smetaNewFloorOptions() {
      const base = Array.isArray(this.smetaNewFloors) ? this.smetaNewFloors : [];
      return [
        { floor_map_id: null, label: 'Все этажи' },
        ...base.map(f => ({ floor_map_id: f.floor_map_id, label: `Этаж ${f.level_num}` })),
      ];
    },
    loadRevitInitialEntranceId() {
      const q = this.$route?.query;
      if (!q?.project_entrance_id) return null;
      const n = Number(q.project_entrance_id);
      return Number.isNaN(n) ? null : n;
    },
    loadRevitInitialBimProjectId() {
      const q = this.$route?.query;
      if (!q?.bim_project_id) return null;
      const n = Number(q.bim_project_id);
      return Number.isNaN(n) ? null : n;
    },
    transferFloorEntranceOptions() {
      return (this.transferFloorEntrances || []).map((e) => ({
        ...e,
        label: `Подъезд ${e.entrance}`,
      }));
    },
    transferFloorFloorOptions() {
      return (this.transferFloorFloors || []).map((f) => ({
        ...f,
        label: `Этаж ${f.level_num || '—'}`,
      }));
    },
    transferFloorTargetOptions() {
      return (this.transferFloorTargetProjects || []).map((p) => ({
        ...p,
        label: `Проект ${p.project_id ?? '—'}`,
      }));
    },
    loadRevitInitialOperationKey() {
      return this.$route?.query?.operation_key || null;
    },
    loadRevitImportInProgress() {
      return this.$route?.query?.importInProgress === '1';
    },
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) return '0';
      const num = parseFloat(value);
      if (isNaN(num)) return '-';
      return num.toLocaleString('ru-RU', { maximumFractionDigits: 0 });
    },
    handleEntranceClick(row, entrance) {
      const queryParams = {
        resident_id: row.resident_id,
        project_type_id: row.project_type_id,
        project_entrance_id: entrance.project_entrance_id,
        project_id: row.project_id,
        tab: 'EntranceSchema'
      };
      if (row.sbs_project_id != null) {
        queryParams.sbs_project_id = row.sbs_project_id;
      }

      const queryString = new URLSearchParams(queryParams).toString();
      const url = `${window.location.origin}/residential-settings?${queryString}`;
      window.open(url, '_blank');
    },
    showChangeMaterialForm(provider_request_item_id) {
      this.showModal(MODAL_NAMES.ProviderRequestsMaterialSelect, {
        onSubmit: (body) => this.onZamenaMaterialsListSubmit(body),
        title: 'Выбрать материал замены',
        clientRequestId: this.clientRequestId,
        provider_request_item_id: provider_request_item_id,
        isZamena: true,
      });
    },
    getFillClass,
    getTextColorByBackground,
    tryOpenLoadRevitDrawer() {
      if (this.pendingOpenLoadRevit == null || !Array.isArray(this.rowsData)) return;
      const projectId = this.pendingOpenLoadRevit;
      const row = this.rowsData.find(r => Number(r.project_id) === Number(projectId));
      this.activeProjectId = projectId;
      this.activeProjectData = row || null;
      this.loadRevitDrawerOpen = true;
      this.pendingOpenLoadRevit = null;
    },
    async getData(options = {}) {
      this.isFetching = true;
      try {
        const res = await getResidentDetailedInfo(this.filterParams, options);
        if (res !== undefined || !options.silent) {
          this.rowsData = res || [];
        }
      } finally {
        this.isFetching = false;
      }
    },
    onSmetaTabChange(value) {
      this.smetaTab = value
    },
    async onEntranceChange(project, entrance) {
      const action = project?.entrances?.includes(entrance) ? 'delete' : 'add';
      const body = {
        project_id: project.project_id,
        entrance: entrance,
        action
      }

      this.changingEntrances = true
      const res = await updateProjectEntrance(body, this.filterParams);
      this.changingEntrances = false

      if (!res) return;
      this.rowsData = res;

      try {
        this.$refs[`popupProjectEntrance${project.project_id}`][0].hide()
      } catch (e) { }
    },
    startTourGuide() {
      this.$nextTick(() => {
        this.$refs.tourGuideManager.startTourGuide();
      });
    },
    openTimeline(row) {
      this.timelineDrawerRow = row;
      this.timelineDrawerOpen = true;
    },
    getCurrentStepForProject(projectStatusCode, projectStatusName) {
      if (!projectStatusCode && !projectStatusName) return 0;

      let statusIndex = this.steps.findIndex(step => step.code === projectStatusCode);

      if (statusIndex === -1 && projectStatusName) {
        statusIndex = this.steps.findIndex(step => step.title === projectStatusName);
      }

      return statusIndex >= 0 ? statusIndex : 0;
    },
    onBackClick() {
      this.$emit("back-to-projects")
    },
    async handleAddClick() {
      this.showModal(MODAL_NAMES.AddProjectEntry, {
        title: "Добавить проект",
        body: {
          resident_id: this.filterParams.resident_id,
          project_type_id: this.filterParams.project_type_id
        },
        onSubmit: this.onAddSubmit,
      })
    },
    async handleEditClick(row) {
      this.showModal(MODAL_NAMES.AddProjectEntry, {
        onSubmit: (body) => this.onUpdateSubmit(body),
        title: "Изменить проект",
        body: row,
      })
    },
    getActionsDropdown() {
      const actions = [
        { label: 'Документы проекта', action: 'projectDocs', group: 'docs' },
        { label: 'Сформировать договор Ген подряда и Подряда', action: 'generateDoc', group: 'docs', type: 'generateDoc' },
        { label: 'Сформировать доп. соглашение', action: 'createDS', group: 'docs' },
        { label: 'Расторжение договора', action: 'agreementCancel', group: 'docs' },

        { label: 'Вид списания', action: 'writeoffInfo', group: 'operations' },
        { label: 'Изменение статуса', action: 'changeStatus', group: 'operations' },
        { label: 'Дублировать подъезд', action: 'duplicateEntrance', group: 'operations' },
        { label: 'Заполнить подъезды', action: 'fillEntranceFlats', group: 'operations' },
        { label: 'Разделить проект', action: 'divideProject', group: 'operations' },
        { label: 'Старт СМР', action: 'startSMR', group: 'operations' },
        { label: 'Подгрузить Revit проект', action: 'loadRevitProject', group: 'operations' },
        { label: 'BIM-смета', action: 'bimDigitalCompare', group: 'operations' },
        { label: 'Работа с этажами', action: 'floorsWork', group: 'operations' },
        { label: 'Перенести этаж или подъезд в другой проект', action: 'transferToProject', group: 'operations' },

        { label: 'Смета ★', action: 'openSmetaHub', group: 'smeta' },
        { label: 'Сравнение договоров', action: 'openSmetaAgreementCompare', group: 'smeta' },
        { label: 'Смета', action: 'projectSmeta', group: 'smeta', hidden: true },
        { label: 'Пересорт материала', action: 'resortMaterial', hideWhenClick: true, group: 'smeta' },
        { label: 'Смета новая', action: 'projectSmetaNew', group: 'smeta', hidden: true },
        { label: 'Журнал изменений сметы', action: 'smetaAnomalies', group: 'smeta', hidden: true },
        { label: 'Смета менеджера', action: 'projectSmetaManager', group: 'smeta', hidden: true },
        { label: 'Сравнить сметы', action: 'compareSmetaVersions', group: 'smeta', hidden: true },
        { label: 'Сравнение сметы новая', action: 'compareSmetaNew', group: 'smeta', hidden: true },
        { label: 'Настройки закупа материалов', action: 'materialSettings', group: 'smeta' },
        { label: 'Заменить материалы', action: 'replaceMaterials', hideWhenClick: true, group: 'smeta' },
      ];
      let filtered = actions.filter((a) => !a.hidden);
      if (!this.hasTransferGrant) {
        filtered = filtered.filter((a) => a.action !== 'transferToProject');
      }
      if (!this.hasWriteoffInfoGrant) {
        filtered = filtered.filter((a) => a.action !== 'writeoffInfo');
      }
      return filtered;
    },
    getGroupLabels(group) {
      if (group === 'docs') return 'Договоры'
      if (group === 'smeta') return 'Смета'
      if (group === 'operations') return 'Операции'
      return group
    },
    getDocsDropdownActions(row) {
      let options = [{ label: 'Сформировать договор Ген подряда и Подряда' }]
      return options
    },
    async handleSMRClick(project_id) {
      this.actionsLoading[project_id] = true;
      const res = await changeProjectStatus(project_id, this.filterParams)
      this.actionsLoading[project_id] = false;
      if (!res) return
      this.rowsData = res
      this.showSucceedSnackbar();
    },
    async handleMaterialsSmetaClick(project_id) {
      this.showModal(MODAL_NAMES.ProjectMaterialsSmeta, {
        title: "Настройки закупа материалов ",
        projectId: project_id,
      })
    },
    async handleExecutorClick(row) {
      this.infoLoading[row.project_id] = true;
      const projInfo = await getProjectInfo(row.project_id);
      const basicData = {
        project_id: row.project_id,
        project_name: row.project_name,
        resident_id: row.resident_id,
        project_type_name: row.project_type_name,
        project_type_id: row.project_type_id,
        resident_name: row.resident_name,
        entrances: row.entrances,
      };
      this.infoLoading[row.project_id] = false;
      if (!projInfo) return;

      this.$emit("show-performers", {
        projectData: projInfo,
        basicData: basicData
      });
    },
    async handleEntranceDuplicateClick(row, project_entrance_id, entrance) {
      try {
        this.$refs[`popup${row?.project_id}-${project_entrance_id}`][0].hide()
      } catch (e) { }

      this.showModal(MODAL_NAMES.CopyPasteEntranceProperties, {
        onSubmit: (body) => this.onCopyPasteEntarancePropertiesSubmit({
          from_project_entrance_id: body.project_entrance_id,
          from_project_id: row.project_id,
          to_project_id: body.project_id,
        }),
        title: "Дублирование подъезда",
        body: { ...row, entrance }
      })
    },
    async handleEntranceTransferClick(row) {
      try {
        this.$refs[`popup${row?.project_id}-${project_entrance_id}`][0].hide()
      } catch (e) { }

      this.showModal(MODAL_NAMES.CopyPasteEntranceProperties, {
        onSubmit: (body) => this.transferProject({
          project_entrance_id_from: body.project_entrance_id,
          project_id_from: row.project_id,
          project_id_to: body.project_id,
        }),
        title: "Разделение проекта",
        isTransfer: true,
        body: row
      })
    },
    async onEditEntrances(resident_id, project_id) {
      this.fetchingEntrances = true;
      const res = await getEntrances(resident_id, { project_id });
      this.fetchingEntrances = false;
      this.entranceOptionsData = res || [];
    },
    async onAddSubmit(body) {
      const res = await updProject(body, this.filterParams);
      if (!res) return;
      this.rowsData = res;
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async onUpdateSubmit(body) {
      const res = await updProject(body, this.filterParams);
      if (!res) return;
      this.rowsData = res;
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async onCopyPasteEntarancePropertiesSubmit(body) {
      const res = await copyPasteEntranceProperties(body, this.filterParams);
      if (!res) return;
      this.rowsData = res;
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async transferProject(body) {
      const res = await transferEntranceProject(body, this.filterParams);
      if (!res) return;
      this.rowsData = res;
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async downloadDoc(project_agreement_id, doc_name) {
      this.infoLoading[project_agreement_id] = true;
      const url = `project_list/project/get_signed_agreement/`
      await downloadFile(url, doc_name || 'Документ', { project_agreement_id }, 'pdf', 'post', false)
      this.infoLoading[project_agreement_id] = false;
    },
    async deleteDoc(project_agreement_id) {
      this.infoLoading[project_agreement_id] = true
      const res = await deleteDoc(project_agreement_id)
      this.infoLoading[project_agreement_id] = false
      if (!res) return
      this.getData()
      this.showSucceedSnackbar()
    },
    async handleClickDoc(project_id) {
      this.infoLoading[project_id] = true;
      const warrantyResRaw = await getWarranty({ project_id });
      this.infoLoading[project_id] = false;

      const warrantyRes = warrantyResRaw?.data ?? warrantyResRaw;
      if (!warrantyRes) return;

      if (warrantyRes.auto === true) {
        this.infoLoading[project_id] = true;
        const res = await generateDoc({ project_id, warranty: warrantyRes.warranty });
        this.infoLoading[project_id] = false;
        if (!res) return;
        this.getData();
        this.showSucceedSnackbar();
        return;
      }

      if (warrantyRes.auto === false) {
        this.showModal(MODAL_NAMES.Select_Warranty, {
          title: "Выберите процент гарантии",
          warranty_contractor: warrantyRes.warranty_contractor,
          warranty_team_project: warrantyRes.warranty_team_project,
          onSubmit: async (selectedWarranty) => {
            this.infoLoading[project_id] = true;
            const res = await generateDoc({ project_id, warranty: selectedWarranty });
            this.infoLoading[project_id] = false;
            if (!res) return;
            this.getData();
            this.showSucceedSnackbar();
            this.closeModal();
          },
        });
      }
    },
    async handleAction(row, action, project_id) {
      if (action === 'divideProject') {
        this.handleEntranceTransferClick(row)
      }
      if (action === 'duplicateEntrance') {
        this.handleEntranceDuplicateClick(row)
      }
      if (action === 'fillEntranceFlats') {
        this.onFillEntranceFlats(project_id)
      }
      if (action === 'startSMR') {
        this.handleSMRClick(project_id)
      }
      if (action === 'materialSettings') {
        this.handleMaterialsSmetaClick(project_id)
      }
      if (action === 'projectSmeta') {
        this.openOpenProjectSmeta(project_id)
      }
      if (action === 'projectSmetaNew') {
        this.openOpenProjectSmetaNew(project_id)
      }
      if (action === 'smetaAnomalies') {
        this.openSmetaAnomalies(project_id)
      }
      if (action === 'projectSmetaManager') {
        this.openProjectSmetaManager(project_id)
      }
      if (action === 'projectDocs') {
        this.openOpenProjectDocs(project_id)
      }
      if (action === 'replaceMaterials') {
        this.openReplaceMaterialsDrawer(project_id)
      }
      if (action === 'resortMaterial') {
        this.openResortMaterialDrawer(project_id)
      }
      if (action === 'loadRevitProject') {
        this.openLoadRevitDrawer(project_id)
      }
      if (action === 'bimDigitalCompare') {
        this.openBimDigitalCompareHandbook(row, project_id)
      }
      if (action === 'compareSmetaVersions') {
        this.openSmetaCompareDrawer(project_id)
      }
      if (action === 'compareSmetaNew') {
        this.openSmetaCompareNewDrawer(project_id)
      }
      if (action === 'openSmetaHub') {
        this.openSmetaHub(project_id)
      }
      if (action === 'openSmetaAgreementCompare') {
        this.openSmetaAgreementCompare(project_id)
      }
      if (action === 'floorsWork') {
        this.openFloorsWork(project_id)
      }
      if (action === 'transferToProject') {
        this.openTransferDialog(row, 'entrance')
      }
      if (action === 'createDS') {
        this.handleCreateDS(project_id, row.finish_date)
      }
      if (action === 'writeoffInfo') {
        this.handleWriteoffInfoClick(row)
      }
      if (action === 'changeStatus') {
        this.openChangeStatusDialog(row)
      }
      if (action === 'agreementCancel') {
        this.handleAgreementCancel(project_id, row)
      }
    },
    async handleWriteoffInfoClick(row) {
      this.showModal(MODAL_NAMES.UpdWriteoffInfo, {
        title: "Вид списания",
        closeModal: this.closeModal,
        body: {
          project_id: row.project_id,
          sbs_sklad_id: row.sbs_sklad_id ?? "",
          sbs_writeoff_company_id: row.sbs_writeoff_company_id ?? "",
          sbs_writeoff_company_name: row.sbs_writeoff_company_name || "",
          can_edit: row.can_edit ?? true,
          uk_sbs_company_id: row.uk_sbs_company_id ?? "",
          uk_sbs_company_name: row.uk_sbs_company_name || "",
          gp_sbs_company_id: row.gp_sbs_company_id ?? "",
          gp_sbs_company_name: row.gp_sbs_company_name || "",
          writeoff_company_changeable: row.writeoff_company_changeable === true,
          writeoff_company_type_code: row.writeoff_company_type_code ?? "",
        },
        onSubmit: async (body) => {
          const res = await updWriteoffInfo(body);
          if (!res) return false;
          await this.getData();
          this.showSucceedSnackbar();
          return true;
        },
      });
    },
    handleCreateDS(project_id, finish_date) {
      this.showModal(MODAL_NAMES.CONFIRM, {
        title: "Сменить дату завершения проекта",
        cancelBtnText: "Оставить и создать ДС",
        btnText: "Сменить",
        onSubmit: async () => {
          this.showModal(MODAL_NAMES.ChangeProjectDate, {
            title: "Сменить дату завершения проекта",
            body: {
              project_id,
              finish_date,
            },
            onSubmit: () => this.getData(),
          })
        },
        onReject: async () => {
          const res = await createDS({project_finish_date: null, project_id})
          if(res) {
            this.getData()
            this.showSucceedSnackbar()
            this.closeModal()
          }
        },
      })
    },
    handleAgreementCancel(project_id, row) {
      this.showModal(MODAL_NAMES.CONFIRM, {
        title: "Расторжение договора",
        isHtml: true,
        message: `<div style="font-size: 14px; line-height: 1.7;">
          <div>Будет создан документ расторжения договора подряда.</div>
          <div style="margin-top: 8px;"><b>ЖК:</b> ${row?.resident_name || '—'}</div>
          <div><b>Тип:</b> ${row?.project_type_name || '—'}</div>
          <div><b>ID проекта:</b> ${project_id}</div>
          <div style="margin-top: 12px; color: #c62828;">
            После обоюдного подписания и успешной отправки в 1С проект перейдёт в статус «Отменён»,
            а договор подряда — в статус «Расторгнут».
          </div>
        </div>`,
        btnText: "Создать расторжение",
        cancelBtnText: "Отмена",
        onSubmit: () => this.submitAgreementCancel(project_id),
      })
    },
    async submitAgreementCancel(project_id) {
      this.actionsLoading[project_id] = true
      const res = await agreementCancel({ project_id })
      this.actionsLoading[project_id] = false
      if (!res) return
      this.closeModal()
      this.getData()
      this.showSucceedSnackbar()
    },
    openReplaceMaterialsDrawer(project_id) {
      this.activeProjectId = project_id
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
      this.isReplaceMaterialsDrawerOpen = true
    },
    openResortMaterialDrawer(project_id) {
      this.activeProjectId = project_id
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
      this.isResortMaterialDrawerOpen = true
    },
    openOpenProjectSmeta(project_id) {
      this.activeProjectId = project_id
      this.smetaDrawerOpen = true
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
    },
    openOpenProjectSmetaNew(project_id) {
      this.activeProjectId = project_id
      this.smetaNewDrawerOpen = true
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
      this.smetaNewEntranceId = null;
      this.smetaNewWhat = 'general';
      this.loadSmetaNewEntrances();
    },
    openSmetaAnomalies(project_id) {
      this.activeProjectId = project_id
      this.smetaAnomaliesDrawerOpen = true
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
    },
    openProjectSmetaManager(project_id) {
      this.activeProjectId = project_id
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
      this.smetaManagerDrawerOpen = true
    },
    openOpenProjectDocs(project_id) {
      this.activeProjectId = project_id
      this.docsDrawerOpen = true
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
    },
    openLoadRevitDrawer(project_id) {
      this.activeProjectId = project_id
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
      this.loadRevitDrawerOpen = true
    },
    openBimDigitalCompareHandbook(row, project_id) {
      const routeData = this.$router.resolve({
        name: 'projectBimSmetaHandbook',
        query: {
          project_id: String(project_id),
          ...(row?.resident_id != null && { resident_id: String(row.resident_id) }),
          ...(row?.project_type_id != null && { project_type_id: String(row.project_type_id) }),
          ...(row?.resident_name && { resident_name: String(row.resident_name) }),
          ...(row?.project_type_name && { project_type_name: String(row.project_type_name) }),
        },
      });
      window.open(routeData.href, '_blank', 'noopener,noreferrer');
    },
    openSmetaCompareDrawer(project_id) {
      this.activeProjectId = project_id
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
      this.smetaCompareDrawerOpen = true
    },
    openSmetaCompareNewDrawer(project_id) {
      this.activeProjectId = project_id
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
      this.smetaCompareNewDrawerOpen = true
    },
    openSmetaHub(project_id) {
      const route = this.$router.resolve({
        name: 'projectSmetaHub',
        params: { project_id },
        query: { tab: 'smeta_new' },
      });
      window.open(route.href, '_blank');
    },
    openSmetaAgreementCompare(project_id) {
      const route = this.$router.resolve({
        name: 'projectAgreementCompare',
        params: { project_id },
      });
      window.open(route.href, '_blank');
    },
    openFloorsWork(project_id) {
      this.activeProjectId = project_id
      this.activeProjectData = this.rowsData.find(row => row.project_id === project_id) || null
      this.floorsWorkDrawerOpen = true
    },
    async openTransferDialog(row, mode = 'floor') {
      this.transferMode = mode
      this.transferFloorDialogOpen = true
      this.transferFloorProjectId = row.project_id
      this.transferFloorRow = row
      this.transferFloorSelectedEntrance = null
      this.transferFloorSelectedFloors = []
      this.transferFloorTargetProjectId = null
      this.transferFloorFloors = []
      this.transferFloorLoading = true
      try {
        const resident_id = row.resident_id ?? this.filterParams?.resident_id
        const project_type_id = row.project_type_id ?? this.filterParams?.project_type_id
        const [entrances, projectsResp] = await Promise.all([
          getProjectEntrances(row.project_id),
          getProjectsForTransfer(row.project_id, {
            ...(resident_id != null && { resident_id }),
            ...(project_type_id != null && { project_type_id }),
          }),
        ])
        this.transferFloorEntrances = Array.isArray(entrances) ? entrances : []
        const rawProjects = projectsResp?.data ?? (Array.isArray(projectsResp) ? projectsResp : null)
        this.transferFloorTargetProjects = Array.isArray(rawProjects) ? rawProjects : []
      } catch (e) {
        this.transferFloorEntrances = []
        this.transferFloorTargetProjects = []
        this.showErrorSnackbar?.(e?.response?.data?.error || e?.message || 'Не удалось загрузить список целевых проектов')
      }
      this.transferFloorLoading = false
    },
    async onTransferFloorEntranceChange(entrance) {
      this.transferFloorSelectedEntrance = entrance
      this.transferFloorSelectedFloors = []
      this.transferFloorFloors = []
      if (!entrance || !this.transferFloorProjectId) return
      this.transferFloorLoading = true
      try {
        const list = await getProjectEntranceFloors(this.transferFloorProjectId, entrance)
        this.transferFloorFloors = Array.isArray(list) ? list : []
      } catch (e) {
        this.transferFloorFloors = []
      }
      this.transferFloorLoading = false
    },
    async submitTransfer() {
      const target_project_id = this.transferFloorTargetProjectId
      if (!target_project_id) return
      if (this.transferMode === 'floor') {
        const floorIds = this.transferFloorSelectedFloors || []
        if (!floorIds.length) return
        this.transferFloorLoading = true
        try {
          const results = await Promise.allSettled(
            floorIds.map((floor_map_id) => copyFloorToProject(floor_map_id, { target_project_id }))
          )
          const failed = results.filter((r) => r.status === 'rejected')
          if (failed.length === 0) {
            this.showSucceedSnackbar(
              floorIds.length === 1
                ? 'Запрос на перенос этажа выполнен.'
                : `Запрос на перенос ${floorIds.length} этажей выполнен.`
            )
            this.transferFloorDialogOpen = false
            await this.getData()
          } else if (failed.length < floorIds.length) {
            this.showSucceedSnackbar(`Перенесено этажей: ${floorIds.length - failed.length}. Ошибок: ${failed.length}.`)
            this.transferFloorDialogOpen = false
            await this.getData()
          } else {
            this.showErrorSnackbar(
              failed[0].reason?.response?.data?.error ||
                failed[0].reason?.message ||
                'Ошибка при переносе этажей'
            )
          }
        } catch (e) {
          this.showErrorSnackbar(e?.response?.data?.error || e?.message || 'Ошибка при переносе этажей')
        }
        this.transferFloorLoading = false
      } else {
        const entranceItem = (this.transferFloorEntrances || []).find(
          (e) => Number(e.entrance) === Number(this.transferFloorSelectedEntrance)
        )
        const project_entrance_id = entranceItem?.project_entrance_id
        if (!project_entrance_id) {
          this.showErrorSnackbar('Выберите подъезд')
          return
        }
        this.transferFloorLoading = true
        try {
          await transferEntranceProject(
            {
              project_entrance_id_from: project_entrance_id,
              project_id_from: this.transferFloorProjectId,
              project_id_to: target_project_id,
            },
            {}
          )
          this.showSucceedSnackbar('Подъезд перенесён в выбранный проект.')
          this.transferFloorDialogOpen = false
          await this.getData({ silent: true })
        } catch (e) {
          this.showErrorSnackbar(e?.response?.data?.error || e?.message || 'Ошибка при переносе подъезда')
        }
        this.transferFloorLoading = false
      }
    },
    async openChangeStatusDialog(row) {
      this.changeStatusProjectId = row.project_id
      this.changeStatusSelectedId = null
      this.changeStatusDialogOpen = true
      const list = await getProjectStatusForChange()
      this.changeStatusOptions = Array.isArray(list) ? list : []
    },
    openDduDownloadDialogByResident() {
      this.dduDownloadResidentId = this.selectedData?.resident_id ?? null
      this.dduDownloadResidentName = this.selectedData?.resident_name ?? ''
      this.dduDownloadDateRange = { from: '', to: '' }
      this.dduDownloadDialog = true
    },
    async onDduDownloadSubmit() {
      this.dduDownloadLoading = true
      const res = await downloadDduReport(
        this.dduDownloadResidentId,
        this.dduDownloadDateRange.from,
        this.dduDownloadDateRange.to
      )
      this.dduDownloadLoading = false
      if (!res) return
      if (!res.has_data) {
        this.showErrorSnackbar(res.message || 'Нет данных за выбранный период')
        return
      }
      const { saveAs } = await import('file-saver')
      saveAs(res.blob, res.filename)
      this.showSucceedSnackbar()
      this.dduDownloadDialog = false
    },
    onChangeStatusSelect(val) {
      this.changeStatusSelectedId = val
    },
    async onSubmitChangeStatus() {
      if (this.changeStatusProjectId == null || this.changeStatusSelectedId == null) return
      this.changeStatusLoading = true
      try {
        await changeProjectStatusById(
          { project_id: this.changeStatusProjectId, project_status_id: this.changeStatusSelectedId },
          this.filterParams
        )
        await this.getData()
        this.changeStatusDialogOpen = false
      } catch (e) {
        await this.getData()
      } finally {
        this.changeStatusLoading = false
      }
    },
    async onFillEntranceFlats(project_id) {
      this.actionsLoading[project_id] = true;
      const res = await fillEntranceFlats(project_id, this.filterParams)
      this.actionsLoading[project_id] = false;
      if (!res) return
      this.rowsData = res.data;
      showToast(res.message, 'info', 5000, { color: "primary", position: 'top-right' })
    },
    handleEditMaterialLimit(row) {
      this.showModal(MODAL_NAMES.AddProjectLimit, {
        title: "Редактировать лимит материалов",
        body: {
          project_id: row.project_id,
          material_sum_limit: row.material_sum_limit,
        },
        onSubmit: (body) => this.onUpdateMaterialLimitSubmit(body),
      })
    },
    async onUpdateMaterialLimitSubmit(body) {
      const res = await updProjectLimit(body, this.filterParams);
      if (!res) return;
      this.rowsData = res;
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async loadSmetaNewEntrances() {
      if (!this.activeProjectId) {
        this.smetaNewEntrances = [];
        return;
      }

      const res = await getProjectEntrances(this.activeProjectId);
      this.smetaNewEntrances = res || [];
    },
    async loadSmetaNewFloors() {
      if (!this.activeProjectId || !this.smetaNewEntranceId) {
        this.smetaNewFloors = [];
        this.smetaNewFloorMapId = null;
        return;
      }
      const entrance = this.smetaNewEntrances.find(
        e => e.project_entrance_id === this.smetaNewEntranceId
      );
      if (!entrance) {
        this.smetaNewFloors = [];
        this.smetaNewFloorMapId = null;
        return;
      }
      const res = await getProjectEntranceFloors(this.activeProjectId, entrance.entrance);
      this.smetaNewFloors = res || [];
    },
    onSmetaNewEntranceChange(value) {
      this.smetaNewEntranceId = value;
      this.smetaNewFloorMapId = null;
      this.smetaNewFloors = [];
      this.loadSmetaNewFloors();
    },
    onSmetaNewFloorChange(value) {
      this.smetaNewFloorMapId = value;
    },
    onSmetaNewWhatChange(value) {
      if (this.smetaNewWhat === value) return;
      this.smetaNewWhat = value;
    },
    async onPreorderChange(row, value) {
      this.preorderLoading = { ...this.preorderLoading, [row.project_id]: true };
      try {
        await setProjectIsPreorder(
          { project_id: row.project_id, is_preorder: value },
          this.filterParams
        );
        await this.getData();
      } catch (e) {
        await this.getData();
      } finally {
        this.preorderLoading = { ...this.preorderLoading, [row.project_id]: false };
      }
    },
    onSmetaConfirmChange(row, value) {
      const actionText = value ? 'утвердить' : 'отменить утверждение'
      const title = value ? 'Утверждение сметы' : 'Отмена утверждения сметы'
      const btnText = value ? 'Утвердить' : 'Отменить утверждение'

      const entrances = Array.isArray(row.entrances_info)
        ? row.entrances_info.map(e => {
            const parts = [`Подъезд ${e.entrance_num || '—'}`]
            if (e.block_name) parts.push(`Блок ${e.block_name}`)
            return parts.join(', ')
          }).join('; ')
        : '—'

      this.showModal(MODAL_NAMES.CONFIRM, {
        title,
        message: `<div style="font-size: 14px; line-height: 1.7;">
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
            <span style="font-size: 20px; color: ${value ? '#4caf50' : '#f44336'};">●</span>
            <span>Вы собираетесь <b>${actionText}</b> смету для проекта <b>${row.project_id}</b></span>
          </div>
          <div style="background: #f5f7fa; border-radius: 8px; padding: 12px 16px; margin-bottom: 12px;">
            <div><b>ЖК:</b> ${row.resident_name || '—'}</div>
            <div><b>Тип:</b> ${row.project_type_name || '—'}</div>
            <div><b>Подъезды:</b> ${entrances}</div>
          </div>
          <div style="color: #666; font-size: 13px;">
            После ${value ? 'утверждения' : 'отмены'} на почту инженеров ПТО, назначенных на этот проект, будет отправлено уведомление.
          </div>
        </div>`,
        isHtml: true,
        btnText,
        cancelBtnText: 'Отмена',
        onSubmit: async () => {
          this.closeModal()
          this.smetaConfirmLoading = { ...this.smetaConfirmLoading, [row.project_id]: true }
          try {
            const res = await setProjectIsSmetaConfirm(
              { project_id: row.project_id, is_smeta_confirm: value },
              this.filterParams
            )
            await this.getData()
            if (res?.notification_error) {
              this.showErrorSnackbar(`Смета ${value ? 'утверждена' : 'отменена'}, но уведомления не отправлены: ${res.notification_error}`)
            } else {
              this.showSucceedSnackbar(value ? 'Смета утверждена. Уведомления отправлены.' : 'Утверждение сметы отменено. Уведомления отправлены.')
            }
          } catch (e) {
            await this.getData()
          } finally {
            this.smetaConfirmLoading = { ...this.smetaConfirmLoading, [row.project_id]: false }
          }
        },
      })
    },
  },
  async mounted() {
    this.getData();
    const [hasTransfer, hasWriteoffInfo] = await Promise.all([
      getHasGrant('M__ProjectTransfer'),
      getHasGrant('M__ProjectWriteoffInfoUpd'),
    ]);
    this.hasTransferGrant = hasTransfer === true;
    this.hasWriteoffInfoGrant = hasWriteoffInfo === true;
  },
  setup() {
    const { showModal, closeModal } = useAppStore()

    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar, showModal, closeModal };
  },
  watch: {
    '$route.query': {
      handler(q) {
        if (q?.openLoadRevit === '1' && q?.project_id) {
          this.pendingOpenLoadRevit = Number(q.project_id);
          this.tryOpenLoadRevitDrawer();
        }
      },
      immediate: true
    },
    rowsData() {
      this.tryOpenLoadRevitDrawer();
    },
    isReplaceMaterialsDrawerOpen(newVal) {
      if (!newVal) {
        this.activeProjectData = null
        this.activeProjectId = null
      }
    },
    smetaDrawerOpen(newVal) {
      if (!newVal) {
        this.activeProjectId = null
      }
    },
    smetaNewDrawerOpen(newVal) {
      if (!newVal) {
        this.activeProjectId = null
        this.smetaNewEntrances = []
        this.smetaNewEntranceId = null
        this.smetaNewFloors = []
        this.smetaNewFloorMapId = null
        this.smetaNewWhat = 'general'
      }
    },
    smetaAnomaliesDrawerOpen(newVal) {
      if (!newVal) {
        this.activeProjectId = null
        this.activeProjectData = null
      }
    },
  }
};
</script>

<style scoped lang="scss">
.top-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__btn {
    background-color: transparent;
    width: auto;

    span {
      margin-left: 8px;
      color: #373D48;
      font-size: 20px;
      font-weight: 600;
      line-height: 20px;
    }
  }

  :deep(.title) {
    margin-bottom: 0 !important;
  }
}

.header {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: end;

  &__filters {
    display: flex;
    gap: 10px;
  }

  &__item {
    width: 200px;
  }

  &__card {
    background-color: #F2F5F8;
    padding: 11px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 22px;
    color: #373D48;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400;
  }

  &__create-btn {
    width: auto;
    height: 46px;

    &--ddu span {
      color: #1976d2;
    }
  }

  &__create-btn-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #fff;
    color: #0060fe;
  }

  :deep(.q-btn__content) {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  @media (max-width: 400px) {
    &__item {
      width: 100%;
    }
  }
}

/* Диалог ДДУ: приятный UI выбора периода */
.ddu-download-card {
  min-width: 420px;
  max-width: 480px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.ddu-download-card__header {
  padding: 20px 24px 16px;
}

.ddu-download-card__title-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.ddu-download-card__icon {
  color: var(--q-primary);
  flex-shrink: 0;
  margin-top: 2px;
}

.ddu-download-card__title {
  font-weight: 600;
  color: #1d1d1d;
  line-height: 1.3;
}

.ddu-download-card__subtitle {
  font-size: 13px;
  color: #6b7280;
  margin-top: 2px;
}

.ddu-download-card__resident {
  margin-top: 14px;
  padding: 10px 14px;
  background: #f3f4f6;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.ddu-download-card__period {
  padding: 20px 24px;
  background: #fafafa;
}

.ddu-download-card__period-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 10px;
  display: block;
}

.ddu-download-card__date-range {
  margin-bottom: 8px;
}

.ddu-download-card__hint {
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.4;
}

.ddu-download-card__actions {
  padding: 14px 24px 18px;
}

/* Даты должны быть видны (глобальные стили делают input[type=date] прозрачным) */
.ddu-download-card :deep(input[type="date"]::-webkit-datetime-edit),
.ddu-download-card :deep(input[type="date"]::-webkit-datetime-edit-year-field),
.ddu-download-card :deep(input[type="date"]::-webkit-datetime-edit-month-field),
.ddu-download-card :deep(input[type="date"]::-webkit-datetime-edit-day-field),
.ddu-download-card :deep(input[type="date"]::-webkit-datetime-edit-text) {
  color: #1d1d1d;
  -webkit-appearance: none;
}
.ddu-download-card :deep(input[type="date"]:in-range::-webkit-datetime-edit-year-field),
.ddu-download-card :deep(input[type="date"]:in-range::-webkit-datetime-edit-month-field),
.ddu-download-card :deep(input[type="date"]:in-range::-webkit-datetime-edit-day-field),
.ddu-download-card :deep(input[type="date"]:in-range::-webkit-datetime-edit-text) {
  color: #1d1d1d;
  display: revert;
}

.smeta-tabs {
  display: flex;
  border-bottom: 2px solid #e5e7eb;
  gap: 0;
}

.smeta-tab {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: #374151;
    border-bottom-color: #d1d5db;
  }
}

.smeta-tab--active {
  color: #2f80ed;
  border-bottom-color: #2f80ed;
  font-weight: 600;
}

.smr-btn {
  font-size: 12px;
  width: auto;
  height: 32px;

  &--disabled {
    background: #D1D5DB;
    color: #373D48 !important;
  }
}

.actions-btn {
  font-size: 12px;
  width: 100%;
  height: 32px;
}

.actions-btn--divide {
  background: #21830b;
  color: #fff;
}

.actions-btn--copy {
  background: #0060fe;
  color: #fff;
}

.item {
  display: flex;
  align-items: center;
  gap: 7px;
  transition: all .3s;
  padding: 5px 10px;
  font-size: 14px;
  color: #404040;
  line-height: 20px;
  min-height: 30px;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
  }
}

.fill-yellow {
  background-color: #fff3cd;
  color: #856404;
  font-weight: bold;
}

.fill-green {
  background-color: #d4edda;
  color: #155724;
  font-weight: bold;
}

/* Тонкий горизонтальный разделитель внутри ячейки (1С-стиль) */
.cell-section-divider {
  width: 100%;
  height: 1px;
  background: #e5e7eb;
  margin: 4px 0;
}

/* 1С-подобная сетка: видимые границы всех ячеек */
.projects-grid-table {
  :deep(table) {
    border-collapse: collapse !important;
  }

  :deep(.q-table tbody td) {
    border-right: 1px solid #e5e7eb !important;
    border-bottom: 1px solid #e5e7eb !important;
  }

  :deep(.q-table thead th) {
    border-right: 1px solid #d1d5db !important;
    border-bottom: 2px solid #d1d5db !important;
    background: #f8f9fb !important;
  }

  :deep(.q-table tbody tr:hover td) {
    background: #f0f6ff !important;
  }
}

.project-status-cancelled {
  color: #c62828;
  font-weight: 700;
}

.step-compact {
  cursor: pointer;
  min-width: 120px;
  padding: 2px 4px;
  border-radius: 4px;
  transition: background 0.15s;

  &:hover {
    background: #f0f4ff;
  }

  &__name {
    font-size: 12px;
    font-weight: 600;
    color: #0060fe;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
  }

  &__bar-row {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__bar {
    flex: 1;
    height: 5px;
    background: #e0e0e0;
    border-radius: 3px;
    overflow: hidden;
  }

  &__bar-fill {
    height: 100%;
    background: #0060fe;
    border-radius: 3px;
    transition: width 0.3s;
  }

  &__fraction {
    font-size: 11px;
    color: #666;
    white-space: nowrap;
  }
}

.step-tooltip {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);

  &__item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 0;
    font-size: 13px;
    color: #999;

    &--done {
      color: #0060fe;
    }

    &--active {
      color: #0060fe;
      font-weight: 700;
    }
  }
}

.toggle-cell-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.text-lg span {
  font-size: "16px";
}

.doc-link {
  cursor: pointer;
  text-decoration: underline;
  color: #666;
}

.doc-link:hover {
  color: #666;
  text-decoration: none;
}

.simple-tooltip {
  padding: 8px 12px !important;
  border-radius: 6px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.tooltip-title {
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 13px;
  color: #fff;
}

.signer-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.signer-row:last-child {
  margin-bottom: 0;
}

.signer-name {
  font-size: 13px;
  margin: 0;
}

.signer-icon {
  font-size: 16px;
}

.doc-1c-icon {
  font-size: 16px;
  margin-left: 4px;
}

.tooltip-section {
  margin-bottom: 8px;
}

.doc-1c-error {
  align-items: flex-start;
}

.doc-1c-error .signer-name {
  color: #ffcdd2;
  max-width: 260px;
  white-space: normal;
  word-break: break-word;
}

</style>

<style>
.v-tour-guide-skip-button {
  display: none !important;
}

.custom-tour-tooltip {
  background-color: #ffffff !important;
  color: #373D48 !important;
  border-radius: 8px !important;
  padding: 8px 16px !important;
}

.custom-tour-header {
  font-size: 22px !important;
  font-weight: 600 !important;
}

.custom-tour-content {
  font-size: 14px !important;
}

.custom-action-btn {
  font-size: 14px !important;
  background-color: transparent !important;
  color: #373D48 !important;
  padding: 6px 16px !important;
  border: 1px solid #9CA3AF !important;
  border-radius: 4px !important;
  margin-top: 6px !important;
}

.custom-tour-actions {
  display: flex;
  gap: 8px;

  div {
    display: flex;
    gap: 8px;
  }
}


.entrance-selector {
  width: 100%;

  &__label {
    font-size: 13px;
    line-height: 13px;
    margin-bottom: 8px;
    color: #262626;
  }
}

.sbs-project-badge {
  display: inline-block;
  font-size: 12px;
  margin-top: 4px;
  padding: 3px 8px;
  background-color: #2196f3;
  color: #ffffff;
  border-radius: 3px;
  font-weight: 500;
  cursor: pointer;
}

.usp-check-link-badge {
  display: inline-block;
  margin-left: 10px;
  padding: 4px 10px;
  background-color: #4caf50;
  color: #ffffff;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.material-limit-badge {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 6px;
  padding: 6px 12px;
  background-color: #f9fafb;
  color: #374151;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;
  position: relative;

  &__content {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex: 1;
  }

  &__wallet-icon {
    color: #6b7280;
    flex-shrink: 0;
  }

  &__text {
    color: #374151;
    white-space: nowrap;
  }

  &__edit-icon {
    color: #9ca3af;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 4px;
    border-radius: 4px;
    flex-shrink: 0;
    opacity: 0.7;

    &:hover {
      color: #0060fe;
      background-color: rgba(0, 96, 254, 0.08);
      opacity: 1;
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  &:hover {
    background-color: #f3f4f6;
    border-color: #d1d5db;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .material-limit-badge__edit-icon {
      opacity: 1;
    }
  }
}
</style>